import { c as _c } from "react/compiler-runtime";
import { type MouseEventHandler, useEffect, useRef, useState } from 'react';

// TODO: add tests to validate functionality
export default function useDragScroll() {
  const $ = _c(11);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [hasMovedAfterClick, setHasMovedAfterClick] = useState(false);
  const [lastMousePosition, setLastMousePosition] = useState(null);
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = event => {
      setIsMouseDown(true);
      setLastMousePosition(event.clientX);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onMouseDown = t0;
  let t1;
  if ($[1] !== hasMovedAfterClick || $[2] !== isMouseDown || $[3] !== lastMousePosition) {
    t1 = () => {
      const captureClick = event_0 => {
        if (hasMovedAfterClick) {
          setHasMovedAfterClick(false);
          event_0.stopPropagation();
        }
      };
      const onMouseUp = () => {
        setIsMouseDown(false);
        setLastMousePosition(null);
      };
      const onMouseMove = event_1 => {
        if (!isMouseDown) {
          return;
        }
        if (ref.current === null) {
          return;
        }
        if (lastMousePosition === null) {
          return;
        }
        const valueToScroll = lastMousePosition - event_1.clientX;
        if (Math.abs(valueToScroll) < 5) {
          return;
        }
        setHasMovedAfterClick(true);
        ref.current.scrollLeft = ref.current.scrollLeft + valueToScroll;
        setLastMousePosition(event_1.clientX);
      };
      window.addEventListener("mouseup", onMouseUp);
      ref.current?.addEventListener("mousemove", onMouseMove);
      ref.current?.addEventListener("click", captureClick, true);
      return () => {
        window.removeEventListener("mouseup", onMouseUp);
        ref.current?.removeEventListener("mousemove", onMouseMove);
        ref.current?.removeEventListener("click", captureClick, true);
      };
    };
    $[1] = hasMovedAfterClick;
    $[2] = isMouseDown;
    $[3] = lastMousePosition;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isMouseDown || $[6] !== lastMousePosition) {
    t2 = [isMouseDown, lastMousePosition];
    $[5] = isMouseDown;
    $[6] = lastMousePosition;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ref,
      onMouseDown
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== hasMovedAfterClick) {
    t4 = {
      dragProps: t3,
      isDragging: hasMovedAfterClick
    };
    $[9] = hasMovedAfterClick;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}